/**
 * Generic API helpers and error envelope used by all V6 endpoints.
 */
import { z } from "zod";
/** All server-emitted errors conform to this shape. */
export const ApiErrorSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    details: z.unknown().optional(),
});
//# sourceMappingURL=api.js.map